var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"list-item"},[_c('div',{staticClass:"field inline row"},[_c('span',{staticClass:"label centered rigid"},[_vm._t("setting-label")],2),_vm._v(" "),_c('span',{staticClass:"row"},[_c('div',{staticClass:"display-text centered rigid"},[_vm._t("setting-value")],2)])]),_vm._v(" "),_c('span',{staticClass:"gap"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-668ef017","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingStatic.vue
// module id = We5s
// module chunks = 1